<template>
    <div class="fill-height case-container">
      <div class="title-container flex-grow-0 flex-shrink-0">
            <span class="case-prop">
              {{  $t('stranger.data.details.name.value') }}
            </span>
      </div>
      <div class="mt-5">
        <div class="case-detail-container flex-grow-0 flex-shrink-0">
            <span class="case-prop-title">
              {{  $t('stranger.data.details.location.label') }} : 
            </span>        
            <span class="case-prop">
              {{  $t('stranger.data.details.location.value') }}
            </span>
        </div>     
        <div class="case-detail-container flex-grow-0 flex-shrink-0">
            <span class="case-prop-title">
              {{  $t('stranger.data.details.status.label') }} : 
            </span>        
            <span v-if="!$strangerStore.solved" class="case-prop">
              {{  $t('stranger.data.details.status.valueNotSolved') }}
            </span>
            <span v-if="$strangerStore.solved" class="case-prop">
              {{  $t('stranger.data.details.status.valueSolved') }}
            </span>            
        </div>   
        <div class="case-detail-container flex-grow-0 flex-shrink-0">
            <span class="case-prop-title">
              - 
            </span>
        </div>         
      </div>      
    </div>
</template>
<script>
export default {
  name: "CaseBar",
  data() {
    return {
      publicPath: process.env.BASE_URL,
      showResolveDialog: false,
    };
  },
  props: {
    caseID: String,
    details: Object,
  },
  methods: {
  },
  computed: {
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/stranger.scss';

.case-container {
  width: 100%;
  text-align: center;
}

.title-container {
  border: 2px solid $accent-color;
  display: inline-block;
  margin-left: 30px;
  margin-right: 30px;
  max-width: 400px;
  font-family: "Amiga4ever";
  font-size: 14px;
  padding: 5px;
  width: calc(100% - 60px);
  text-align: center;

  .case-prop {
    color: $accent-color;    
  }
}

.case-detail-container {
  display: block;
  max-width: 400px;
  font-family: "Amiga4ever";
  font-size: 14px;
  padding: 1px;
  width: calc(100% - 60px);
  text-align: left;
  margin:auto;
}

.case-prop, .case-prop-title {
  color: $accent-color;
  font-family: "Amiga4ever";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.06em;
  text-align: left;
  padding-left: 8px;
  text-transform: uppercase;
} 

.case-prop-title {
  color: $light-color;
}

@media (max-width: 600px) {
  .case-prop, .case-prop-title {
    font-size: 12px;

  }
}

</style>